import { isStationModeEnabled } from './helpers';

export interface SearchParams {
  query: string;
  tab?: 'all' | 'albums' | 'tracks' | 'contributors' | 'companions';
}

export interface SearchResult {
  success: boolean;
  error?: string;
}

let navigateFunction: ((path: string) => void) | null = null;

export const setNavigateFunction = (navigate: (path: string) => void) => {
  navigateFunction = navigate;
};

export const performSearch = async (
  params: SearchParams,
): Promise<SearchResult> => {
  if (!isStationModeEnabled()) {
    return {
      success: false,
      error: 'Station mode is not enabled',
    };
  }

  try {
    const { query, tab } = params;

    if (!query || !query.trim()) {
      return {
        success: false,
        error: 'Search query is required',
      };
    }

    const searchParams = new URLSearchParams();
    searchParams.set('q', query.trim());
    if (tab) {
      searchParams.set('searchTab', tab);
    }

    const searchUrl = `/search?${searchParams.toString()}`;

    if (navigateFunction) {
      navigateFunction(searchUrl);
    } else {
      window.location.href = searchUrl;
      return {
        success: false,
        error: 'Navigation not initialized',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Failed to perform search:', error);
    }
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};
